import axios from "@/vue-axios/service.js";

const Authorization = ({ email, password }) => {
  return axios
    .get(
      `login?email=${encodeURIComponent(email)}&password=${encodeURIComponent(
        password
      )}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { status: false, message: error.response?.data?.message || "Login failed. Please try again." };
    });
};

export default Authorization;
